import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { loadDOMComponent } from '../../../../helpers';
import { AppContextProvider } from '../../../../Services/AppContext';
import { store } from '../../../../store/store';
import React from 'react';
import SUKLCredentialsSetupWrapper from './SUKLCredentialsSetupWrapper';

loadDOMComponent({
	selector: 'react-sukl-credentials-setup',
	callback: ({ container, context }: any) => {
		ReactDOM.render(
			<Provider store={store}>
				<AppContextProvider {...context}>
					<SUKLCredentialsSetupWrapper />
				</AppContextProvider>
			</Provider>,
			container,
		);
	},
});
